import { CheckboxAttribute } from '../../../types/CheckboxAttribute';

import styles from './CheckBox.module.scss';

import type { FC, ChangeEventHandler } from 'react';

import { assertNever } from '@/packages/nurse-senka-frontend-sdk';

export type Props = {
  columns: 'default' | 'three';
  attributes: CheckboxAttribute[];
  onChange?: ChangeEventHandler<HTMLInputElement>;
  isUseChecked?: boolean;
};

const CheckBoxList: FC<Props> = ({ attributes, onChange, isUseChecked }) => (
  <>
    {attributes.map((checkboxProps) => (
      <label
        className={styles['wrap-inner']}
        key={checkboxProps.value}
        htmlFor={checkboxProps.id}
      >
        {isUseChecked ? (
          <input
            className={styles.input}
            type="checkbox"
            name={checkboxProps.name}
            id={checkboxProps.id}
            value={checkboxProps.value}
            onChange={onChange}
            checked={checkboxProps.checked ? checkboxProps.checked : false}
          ></input>
        ) : (
          <input
            className={styles.input}
            type="checkbox"
            name={checkboxProps.name}
            id={checkboxProps.id}
            value={checkboxProps.value}
            onChange={onChange}
          ></input>
        )}
        <span className={styles.text}>{checkboxProps.label}</span>
      </label>
    ))}
  </>
);

const CheckBoxListThree: FC<Props> = ({
  attributes,
  onChange,
  isUseChecked,
}) => (
  <>
    {attributes.map((checkboxProps) => (
      <label
        className={styles['wrap-three']}
        key={checkboxProps.value}
        htmlFor={checkboxProps.id}
      >
        {isUseChecked ? (
          <input
            className={styles.input}
            type="checkbox"
            name={checkboxProps.name}
            id={checkboxProps.id}
            value={checkboxProps.value}
            onChange={onChange}
            checked={checkboxProps.checked ? checkboxProps.checked : false}
          ></input>
        ) : (
          <input
            className={styles.input}
            type="checkbox"
            name={checkboxProps.name}
            id={checkboxProps.id}
            value={checkboxProps.value}
            onChange={onChange}
          ></input>
        )}
        <span className={styles['text-three']}>{checkboxProps.label}</span>
      </label>
    ))}
  </>
);

export const CheckBox: FC<Props> = ({
  attributes,
  columns,
  onChange,
  isUseChecked,
}) => {
  switch (columns) {
    case 'default':
      return (
        <div className={styles.wrap}>
          <CheckBoxList
            columns="default"
            attributes={attributes}
            onChange={onChange}
            isUseChecked={isUseChecked}
          />
        </div>
      );
    case 'three':
      return (
        <div className={styles.wrap}>
          <CheckBoxListThree
            columns="default"
            attributes={attributes}
            onChange={onChange}
            isUseChecked={isUseChecked}
          />
        </div>
      );
    default:
      return assertNever(columns);
  }
};
